import React, { useState } from "react";
import {
  Button,
  Card,
  Container,
  Row,
  Col,
  ProgressBar,
} from "react-bootstrap";
import { FaTree } from "react-icons/fa"; // Add tree icon for better visuals

const SaveTrees = () => {
  const [treesSaved, setTreesSaved] = useState(0);
  const [totalTreesSaved, setTotalTreesSaved] = useState(0);

  // Function to handle saving a tree (on e-receipt selection)
  const handleSaveTree = () => {
    setTreesSaved(treesSaved + 1);
    setTotalTreesSaved(totalTreesSaved + 1);
  };

  return (
    <Container className="text-center mt-5">
      {/* Title */}
      <Row>
        <Col>
          <h1>Save Trees with E-Receipts</h1>
          <p>
            Choose to receive your receipt digitally and contribute to saving
            trees!
          </p>
        </Col>
      </Row>
      {/* Message Section */}
      <Row>
        <Col>
          <Card className="mb-4" style={{ border: '2px solid #007bff', borderRadius: '8px' }}>
            <Card.Body>
              <FaTree size={40} color="green" />
              <h3>
                {treesSaved} Tree{treesSaved !== 1 ? "s" : ""} Saved!
              </h3>
              <p>Each e-receipt you choose helps protect the environment.</p>
              <ProgressBar
                now={(treesSaved / 1000) * 100}
                label={`Saved ${treesSaved} Trees`}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Button to opt for an e-receipt */}
      <Row>
        <Col>
          <Button variant="success" onClick={handleSaveTree}>
            Opt for E-Receipt and Save a Tree
          </Button>
        </Col>
      </Row>

      {/* Global Tree Counter */}
      <Row className="mt-4">
        <Col>
          <h5>Total Trees Saved by All Users: {totalTreesSaved}</h5>
          <p>
            Join the global effort to save the planet one receipt at a time.
          </p>
        </Col>
      </Row>
      <Row>
        <Col></Col>
      </Row>
    </Container>
  );
};

export default SaveTrees;
